import React from 'react';
import Translation from '../translation/translation';

function FSRemoveLightBoxHeader() {
    return (
        <div className="fs-remove-light-box__header fs-remove-light-box-header">
            <Translation
                translationKey="fs-remove-light-box-header"
                className="fs-remove-light-box-header__headline"
            />
        </div>
    );
}

export { FSRemoveLightBoxHeader };
